import React, { useContext } from "react";
import { UserContext } from "../../context/userContext";
import { getProfileImageUrl } from "../../utils/helpers";
import axios from "../../utils/axios";
import {
  Container,
  Row,
  Col,
  Card,
  Alert,
  CardBody,
  Button,
  Label,
  Input,
  FormFeedback,
  Form,
} from "reactstrap";

// Formik Validation
import * as Yup from "yup";
import { useFormik } from "formik";

//redux
import { useDispatch } from "react-redux";
import withRouter from "components/Common/withRouter";

// actions
import { editProfile } from "../../store/actions";

const UserProfile = () => {
  const { userData, setUserData } = useContext(UserContext);
  const [loading, setLoading] = React.useState(false);
  const [apiError, setApiError] = React.useState('');
  const [successMessage, setSuccessMessage] = React.useState('');

  //meta title
  document.title = "Profile | Equity Dashboard";

  const validation = useFormik({
    enableReinitialize: true,
    initialValues: {
      name: userData?.name || '',
      email: userData?.email || '',
      username: userData?.username || '',
      idx: userData?.id || '',
    },
    validationSchema: Yup.object({
      username: Yup.string().required("Please Enter Your UserName"),
    }),
    onSubmit: async (values, { setSubmitting }) => {
      try {
        setLoading(true);
        setApiError('');
        setSuccessMessage('');
        
        const response = await axios.post('/api/user/update', values);
        
        if (response.data) {
          setSuccessMessage('Profile updated successfully!');
          // Update the user context with new data
          setUserData({
            ...userData,
            name: values.name,
            email: values.email,
            username: values.username
          });
        }
      } catch (error) {
        console.error('Error updating profile:', error);
        setApiError(error.response?.data?.message || 'Failed to update profile. Please try again.');
      } finally {
        setLoading(false);
        setSubmitting(false);
      }
    }
  });


  return (
    <React.Fragment>
      <div className="page-content p-0">
        <Container fluid>
          {apiError && (
            <div className="mb-3">
              <Alert color="danger">{apiError}</Alert>
            </div>
          )}
          {successMessage && (
            <div className="mb-3">
              <Alert color="success">{successMessage}</Alert>
            </div>
          )}
          <Row>
            <Col lg="12">
              <Card>
                <CardBody>
                  <div className="d-flex">
                    <div className="ms-3">
                      <img
                        src={getProfileImageUrl(userData??'')}
                        alt=""
                        className="avatar-md rounded-circle img-thumbnail"
                      />
                    </div>
                    <div className="flex-grow-1 align-self-center">
                      <div className="text-muted">
                        <h5>{userData?.name || 'N/A'}</h5>
                        <p className="mb-1">{userData?.email || 'N/A'}</p>
                        <p className="mb-0">Id no: #{userData?.id || 'N/A'}</p>
                      </div>
                    </div>
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>

          <h4 className="card-title mb-4">Change User Name</h4>

          <Card>
            <CardBody>
              <Form
                className="form-horizontal"
                onSubmit={(e) => {
                  e.preventDefault();
                  validation.handleSubmit();
                  return false;
                }}
              >
                                <div className="form-group">
                  <Label className="form-label">Name</Label>
                  <Input
                    name="name"
                    // value={name}
                    className="form-control"
                    placeholder="Enter Name"
                    type="text"
                    onChange={validation.handleChange}
                    onBlur={validation.handleBlur}
                    value={validation.values.name || ""}
                    invalid={
                      validation.touched.name && validation.errors.name ? true : false
                    }
                  />
                  {validation.touched.name && validation.errors.name ? (
                    <FormFeedback type="invalid">{validation.errors.name}</FormFeedback>
                  ) : null}
                  <Input name="idx" value={validation.values.idx || ''} type="hidden" />
                </div>
                <div className="form-group">
                  <Label className="form-label">User Name</Label>
                  <Input
                    name="username"
                    // value={name}
                    className="form-control"
                    placeholder="Enter User Name"
                    type="text"
                    onChange={validation.handleChange}
                    onBlur={validation.handleBlur}
                    value={validation.values.username || ""}
                    invalid={
                      validation.touched.username && validation.errors.username ? true : false
                    }
                  />
                  {validation.touched.username && validation.errors.username ? (
                    <FormFeedback type="invalid">{validation.errors.username}</FormFeedback>
                  ) : null}
                  <Input name="idx" value={validation.values.idx || ''} type="hidden" />
                </div>
                <div className="form-group">
                  <Label className="form-label">Email</Label>
                  <Input
                    name="email"
                    // value={name}
                    className="form-control"
                    placeholder="Enter Email"
                    type="email"
                    onChange={validation.handleChange}
                    onBlur={validation.handleBlur}
                    value={validation.values.email || ""}
                    invalid={
                      validation.touched.email && validation.errors.email ? true : false
                    }
                  />
                  {validation.touched.email && validation.errors.email ? (
                    <FormFeedback type="invalid">{validation.errors.email}</FormFeedback>
                  ) : null}
                  <Input name="idx" value={validation.values.idx || ''} type="hidden" />
                </div>
                <div className="text-center mt-4">
                  <Button type="submit" color="danger" disabled={loading}>
                    {loading ? 'Updating...' : 'Update User Name'}
                  </Button>
                </div>
              </Form>
            </CardBody>
          </Card>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default withRouter(UserProfile);
